/**
 * @author Owais Liaquat Ali
 * @datetime Aug, 16th 2023
 */

// Const for Access Point Status
export const accessPointStatusResponse: any = {
  0: 'Unassigned', // Represents an unassigned access point
  1: 'Assigned', // Represents an assigned access point
};

// Const for Unit Status
export const unitStatusResponse: any = {
  0: 'Vacant',
  1: 'Occupied',
};

// Const for User Types
export const userTypeResponse: any = {
  1: 'Property Manager Admin',
  2: 'Property Manager User',
  3: 'Installer Admin',
  4: 'Installer User',
  5: 'Resident',
  6: 'Resident',
  7: 'Resident',
  8: 'EOL Tester',
};

// Const for Activation State
export const activationStateResponse: any = {
  0: 'PENDING_ACTIVATION',
  1: 'ACTIVATED',
  2: 'PENDING_DEACTIVATION',
};

// Const for Device Status
export const deviceStatusResponse: any = {
  1: 'Locked',
  2: 'Unlocked',
};

// Const for Battery Alarms
export const batteryAlarmResponse: any = {
  0: 'No battery alarm',
  1: 'Low battery',
  2: 'Very low battery',
  3: 'Too low to operate battery',
};

// Const for Access Levels
export const accessLevelResponse: any = {
  1: 'Resident Admin',
  2: 'Resident',
};

// Const for Card Status
export const cardStatusResponse: any = {
  1: 'PENDING',
  2: 'ACTIVE',
  3: 'PENDING_BLOCKED',
  4: 'BLOCKED',
};

// Const for Device Modes
export const deviceModeResponse: any = {
  1: 'STATIC_STATE_LOCKED',
  2: 'STATIC_STATE_UNLOCKED',
};

// Const for Device States
export const deviceStateResponse: any = {
  0: 'OFFLINE',
  1: 'ONLINE',
};

// Const for Device Opened States
export const deviceOpenedStateResponse: any = {
  0: 'CLOSED',
  1: 'OPENED',
};
